import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ReceiptText, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";
import { scrollToId } from "@/lib/api";

const BillGuy = () => {
  const [shock, setShock] = useState(false);
  useEffect(() => {
    const t = setInterval(() => setShock((s) => !s), 2200);
    return () => clearInterval(t);
  }, []);
  return (
    <motion.div
      data-testid="bill-guy"
      className="relative w-full max-w-[480px] mx-auto aspect-[1370/1735]"
      animate={
        shock
          ? { scale: 1.07, y: -10, rotate: [0, -2.5, 2.5, -1.5, 1, 0] }
          : { scale: 1, y: 0, rotate: 0 }
      }
      transition={{ duration: 0.5, ease: "easeOut" }}
      style={{ transformOrigin: "50% 100%" }}
    >
      <img
        src="/mascot/bill-calm.webp"
        alt="Homeowner calmly reading his water bill"
        draggable={false}
        className={`absolute inset-0 w-full h-full object-contain object-bottom select-none transition-opacity duration-150 ${shock ? "opacity-0" : "opacity-100"}`}
      />
      <img
        src="/mascot/bill-shock.webp"
        alt="Homeowner shocked by a monster water bill"
        draggable={false}
        className={`absolute inset-0 w-full h-full object-contain object-bottom select-none transition-opacity duration-150 ${shock ? "opacity-100" : "opacity-0"}`}
      />
    </motion.div>
  );
};

export const WaterBill = () => (
  <section data-testid="water-bill-section" className="py-24 sm:py-32 bg-tpink noise-overlay relative">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-center">
      <Reveal>
        <p className="font-bold text-xs tracking-[0.3em] text-white/80 uppercase mb-4">Chapter 04 — The silver lining</p>
        <h2 className="font-bebas text-5xl sm:text-6xl lg:text-7xl text-white leading-[0.9]">
          GOT SLUGGED WITH A <span className="text-tlime">MONSTER WATER BILL?</span>
        </h2>
        <p className="mt-6 text-white/90 text-base sm:text-lg max-w-xl">
          A monster bill usually means a hidden leak. Once we've fixed it, we hand you a detailed
          invoice — lodge it with the Water Corporation and they'll often credit the excess back.
          The leak pays for its own detective. Poetic.
        </p>
        <p className="mt-4 text-xs text-white/60 max-w-xl">
          * Applies to unusually high water bills caused by leaks. Doesn't extend to gas leaks — Water Corp handles water, not gas.
        </p>
        <button
          data-testid="water-bill-cta"
          onClick={() => scrollToId("book")}
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy text-white font-bebas text-xl tracking-wide px-8 py-3.5 hover:bg-navy-light hover:-translate-y-0.5 transition-[transform,background-color] duration-300"
        >
          CHASE THAT CREDIT <ArrowRight className="w-5 h-5" />
        </button>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="relative lg:-my-8">
          <BillGuy />
          <div className="absolute -bottom-6 -left-4 sm:-left-8 bg-white rounded-2xl shadow-xl shadow-navy/10 p-5 flex items-center gap-4 border border-border">
            <ReceiptText className="w-8 h-8 text-brand" />
            <div>
              <p className="font-bebas text-2xl text-navy leading-none">INVOICE = PROOF</p>
              <p className="text-xs text-navy/50">Lodge it with Water Corp</p>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
